import { render, staticRenderFns } from "./numberstr.vue?vue&type=template&id=59d710f8&"
import script from "./numberstr.vue?vue&type=script&lang=js&"
export * from "./numberstr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports